import { ILinkedObjectSpecifiable, ITableIndex } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { IntegerTranslator } from "../../values";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class LinkedOjbectTranslator implements ILinkedObjectTranslatable<ILinkedObjectSpecifiable> {
  constructor(isItemBeanEnable?: (b: IXElementContentsObjectRelationalItemBean) => boolean) {
    this.isItemBeanEnable = isItemBeanEnable
      ? isItemBeanEnable
      : b => true;
  }

  private readonly isItemBeanEnable: (b: IXElementContentsObjectRelationalItemBean) => boolean;

  from(bean: IXElementContentsObjectRelationalItemBean): ILinkedObjectSpecifiable {
    return this.isItemBeanEnable(bean)
      ? {
        type: bean["@type"],
        id: this.integer.from(bean["@obj-id"]),
        key: bean["@key"],
        subKey: bean["@subkey"],
        tableIndex: this.tableIndex.from(bean),
        isDate: ((bean["@option"] !== undefined) && (bean["@option"] !== null))
          ? (bean["@option"] === "1")
          : undefined,
      }
      : null;
  }

  to(object: ILinkedObjectSpecifiable): IXElementContentsObjectRelationalItemBean {
    const tableIndex = this.tableIndex.to(object.tableIndex);
    return {
      "@item-type": "1",
      "@type": object.type,
      "@key": object.key,
      "@subkey": object.subKey,
      "@obj-id": this.integer.to(object.id),
      "@row": tableIndex.row,
      "@column": tableIndex.column,
      "@option": ((object.isDate !== undefined) && (object.isDate !== null))
        ? (object.isDate ? "1" : "2")
        : undefined,
    };
  }

  private readonly integer = new IntegerTranslator();
  private readonly tableIndex = new LinkedObjectTableIndexTranslator();
}

export class LinkedObjectTableIndexTranslator {
  from(bean: IXElementContentsObjectRelationalItemBean): ITableIndex {
    const row = this.integer.from(bean["@row"]);
    const column = this.integer.from(bean["@column"]);
    return ((row !== null) && (column !== null))
      ? {
        row,
        column,
      }
      : undefined;
  }

  to(object: ITableIndex) {
    return {
      row: object ? this.integer.to(object.row) : undefined,
      column: object ? this.integer.to(object.column) : undefined,
    };
  }

  private readonly integer = new IntegerTranslator();
}
